const initialState = { isLoading: false, data: null };
const registrationPending = (state) => ({
  ...state,
  isLoading: true,
  data: null,
});
const registrationFullfilled = (state, payload) => ({
  ...state,
  isLoading: false,
  data: payload?.payload?.data?.data,
});
const registrationRejected = (state) => ({
  ...state,
  isLoading: false,
  data: null,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case "REGISTRATION_PENDING":
      return registrationPending(state, action);

    case "REGISTRATION_FULFILLED":
      return registrationFullfilled(state, action);

    case "REGISTRATION_REJECTED":
      return registrationRejected(state, action);

    default:
      return {
        ...state,
      };
  }
}
